const urlCatalogo = 'https://kierosrl.catalogo.pre-produccion.com/'
const urlBackend = 'https://kierosrl.backend.pre-produccion.com/'
export { urlCatalogo, urlBackend }